var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7812 6.125H4.21875C4.06406 6.125 3.9375 6.25156 3.9375 6.40625V8.65625C3.9375 8.81094 4.06406 8.9375 4.21875 8.9375H31.7812C31.9359 8.9375 32.0625 8.81094 32.0625 8.65625V6.40625C32.0625 6.25156 31.9359 6.125 31.7812 6.125ZM31.7812 28.0625H4.21875C4.06406 28.0625 3.9375 28.1891 3.9375 28.3438V30.5938C3.9375 30.7484 4.06406 30.875 4.21875 30.875H31.7812C31.9359 30.875 32.0625 30.7484 32.0625 30.5938V28.3438C32.0625 28.1891 31.9359 28.0625 31.7812 28.0625ZM31.7812 17.0938H4.21875C4.06406 17.0938 3.9375 17.2203 3.9375 17.375V19.625C3.9375 19.7797 4.06406 19.9062 4.21875 19.9062H31.7812C31.9359 19.9062 32.0625 19.7797 32.0625 19.625V17.375C32.0625 17.2203 31.9359 17.0938 31.7812 17.0938Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.31992a94d15ffd6c7afde40d01b835f3.svg";
export { ForwardRef as ReactComponent };